import AdminSection from '@/views/admin/AdminSection.vue';
import AdminDashBoards from '@/views/admin/tabs/dashboards/AdminDashBoards.vue';
import AdminDashBoardIndex from '@/views/admin/tabs/dashboards/tabs/AdminDashBoardIndex.vue';
import Organizations from '@/views/admin/tabs/organizations/Organizations.vue';
import Organization from '@/views/admin/tabs/organizations/Organization.vue';
import OrganizationsList from '@/views/admin/tabs/organizations/OrganizationsList.vue';
import OrganizationDetails from '@/views/admin/tabs/organizations/tabs/OrganizationDetails.vue';
import OrganizationCreate from '@/views/admin/tabs/organizations/tabs/OrganizationCreate.vue';
import AnalyticsSectionAdmin from '@/views/admin/tabs/analytics/AnalyticsSectionAdmin.vue';
import AnalyticsAdmin from '@/views/admin/tabs/analytics/AnalyticsAdmin.vue';
import AnalyticCreateAdmin from '@/views/admin/tabs/analytics/AnalyticCreateAdmin.vue';
import AnalyticAdmin from '@/views/admin/tabs/analytics/AnalyticAdmin.vue';
import AnalyticDetails from '@/views/analytics/tabs/AnalyticDetails.vue';
import AnalyticDelete from '@/views/analytics/tabs/AnalyticDelete.vue';
import AnalyticEdit from '@/views/analytics/tabs/AnalyticEdit.vue';
import Releases from '@/views/admin/tabs/releases/Releases.vue';
import Release from '@/views/admin/tabs/releases/Release.vue';
import ReleasesList from '@/views/admin/tabs/releases/ReleasesList.vue';
import ReleaseDetails from '@/views/admin/tabs/releases/tabs/ReleaseDetails.vue';
import ReleaseCreate from '@/views/admin/tabs/releases/tabs/ReleaseCreate.vue';

export default [
  {
    path: '/admin',
    component: AdminSection,
    meta: {
      breadcrumb: {
        linkName: 'admin.dashboards.index',
        linkText: 'Admin',
      },
    },
    children: [
      {
        path: '',
        component: AdminDashBoards,
        children: [
          {
            path: '',
            component: AdminDashBoardIndex,
            name: 'admin.dashboards.index',
            children: [],
          },
        ],
      },
      {
        path: 'organizations',
        component: Organizations,
        meta: {
          breadcrumb: {
            linkName: 'admin.organizations.index',
            linkText: 'Organizations',
          },
        },
        children: [
          {
            path: '',
            component: OrganizationsList,
            name: 'admin.organizations.index',
            children: [],
          },
          {
            path: 'create',
            component: OrganizationCreate,
            name: 'admin.organizations.index.create',
          },
          {
            path: ':id',
            component: Organization,
            children: [
              {
                path: '',
                component: OrganizationDetails,
                name: 'admin.organizations.index.detail',
              },
            ],
          },
        ],
      },
      {
        path: 'analytics',
        component: AnalyticsSectionAdmin,
        meta: {
          breadcrumb: {
            linkName: 'admin.analytics.index',
            linkText: 'Analytics',
          },
        },
        children: [
          {
            path: '',
            component: AnalyticsAdmin,
            name: 'admin.analytics.index',
          },
          {
            path: 'create',
            component: AnalyticCreateAdmin,
            name: 'admin.analytics.index.create',
          },
          {
            path: ':id',
            component: AnalyticAdmin,
            meta: {
              breadcrumb: {
                linkName: 'admin.analytics.index.detail',
                linkText: 'Analytic Info',
              },
            },
            children: [
              {
                path: '',
                name: 'admin.analytics.index.detail',
                component: AnalyticDetails,
                props: true,
              },
              {
                path: 'edit',
                name: 'admin.analytics.index.detail.edit',
                component: AnalyticEdit,
                props: true,
              },
              {
                path: 'delete',
                name: 'admin.analytics.index.detail.delete',
                component: AnalyticDelete,
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: 'releases',
        component: Releases,
        meta: {
          breadcrumb: {
            linkName: 'admin.releases.index',
            linkText: 'Releases',
          },
        },
        children: [
          {
            path: '',
            component: ReleasesList,
            name: 'admin.releases.index',
            children: [],
          },
          {
            path: 'create',
            component: ReleaseCreate,
            name: 'admin.releases.index.create',
          },
          {
            path: ':id',
            component: Release,
            children: [
              {
                path: '',
                component: ReleaseDetails,
                name: 'admin.releases.index.detail',
              },
            ],
          },
        ],
      },
    ],
  },
];
